module.exports = __webpack_public_path__ + "img/find-student-badge.8b2c23ac.png";